






































































































































































































































































































import { Component, Emit, Vue, Watch } from "vue-property-decorator";
import { MEETING_TYPE } from "@/resources/constants/meeting";
import { mixins } from "vue-class-component";
import UserValidator from "@/resources/mixins/userValidator";
import { CHAT_TYPE } from "@/resources/constants/chat";
import FloatMenuAnimation from "@/resources/mixins/animations/floatMenuAnimation";
import feather from "feather-icons";
import { ClickOutsideDirective } from "@/helpers/directives/clickOutside.directive";
import EmojiSelectorComponent from "@/app/views/nubii/components/graphicClientOptions/components/emojiSelector.component.vue";
import { SpaceInterface } from "@/resources/interfaces/spaceInterfaces";
import { TYPES_MESSAGES } from "@/resources/constants/messages";
import { SpaceUserInterface } from "@/resources/interfaces/spaceUserInterfaces";
import Loader, { CANCELLATION_TIME } from "@/resources/mixins/loader/loader";
import { i18n } from "@/resources/locales";
import Plans from "@/resources/mixins/plans/plans";
import { PLAN } from "@/resources/constants/plan";
@Component({
  name: "call-actions-component",
  components: { EmojiSelectorComponent },
  directives: { ClickOutsideDirective },
})
export default class CallActionsComponent extends mixins(
  UserValidator,
  FloatMenuAnimation,
  Loader,
  Plans
) {
  MEETING_TYPE = MEETING_TYPE;
  WEBINAR = MEETING_TYPE.WEBINAR;
  ONE_TO_ONE = MEETING_TYPE.ONE_TO_ONE;
  SPEED_NETWORKING = MEETING_TYPE.SPEED_NETWORKING;
  PLAN = PLAN;
  disableCallButton = false;
  feather = feather;
  userChat = null;
  pressToTalk = false;
  isHandUp = false;
  activateRetryCall = false;
  isTeams = false;
  isTeamsAPP = localStorage.getItem("isTeams");
  isSafari = false;
  mounted() {
    this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    this.pressToTalkEvent();
    setTimeout(() => {
      this.userChat = this.$store.getters["ChatStore/getUserChat"];
    }, 2000);
    feather.replace();
    const space = this.$store.getters["SpaceStore/getSpace"];
    this.isTeams = space?.superSpace?.isTeams;
  }
  get video(): boolean {
    feather.replace();
    return this.$store.getters["MeetingStore/getCameraEnabled"];
  }
  get mic(): boolean {
    return this.$store.getters["MeetingStore/getMicEnabled"];
  }
  get shared(): boolean {
    return this.$store.getters["MeetingStore/getSharedScreenEnabled"];
  }
  get meetingType(): string {
    return this.$store.getters["MeetingStore/getMeetingType"];
  }
  get unSeeMessage() {
    return this.$store.getters["ChatStore/getUnSeenMessage"];
  }
  get showBadgeNewMessage() {
    const roomId = this.$store.getters["MeetingStore/getRoomId"];
    return this.unSeeMessage.filter(
      (a) =>
        a.type === CHAT_TYPE.ROOM &&
        JSON.parse(a.payload.Metadata).roomId === roomId
    ).length;
  }
  get showLoockOrUnLoockIcon(): boolean {
    const space = this.$store.getters["SpaceStore/getSpace"] as SpaceInterface;
    const roomId = this.$store.getters["MeetingStore/getRoomId"];
    return space.scenario.rooms.filter((a) => a.id === roomId)[0]?.hasPin;
  }
  get getReservation(): boolean {
    let active = true;
    const space = this.$store.getters["SpaceStore/getSpace"] as SpaceInterface;
    const roomId = this.$store.getters["MeetingStore/getRoomId"];
    const reservationStatus = space.scenario.rooms.filter(
      (a) => a.id === roomId
    )[0]?.reservationStatus;
    if (reservationStatus != "FREE") active = false;
    return active;
  }
  get isVideoUrlLockedByAdmin(): boolean {
    return this.$store.getters["MeetingStore/getIsVideoUrlLockedByAdmin"];
  }
  get isEditLockedByAdmin(): boolean {
    const spaceUser: SpaceUserInterface =
      this.$store.getters["UserStore/getSpaceUser"];
    const space = this.$store.getters["SpaceStore/getSpace"];
    const roomId = this.$store.getters["MeetingStore/getRoomId"];
    const isLockedByAdmin = space.scenario.rooms.filter(
      (a) => a.id === roomId
    )[0]?.isLockedByAdmin;
    const roles = localStorage.getItem("roles");

    if (roles.includes("ROLE_SUPER_ADMIN")) return true;
    if (
      space.createdBy.id === spaceUser.superSpaceUser.user.id ||
      space.superSpace.createdBy.id == spaceUser.superSpaceUser.user.id ||
      spaceUser.isAdmin ||
      spaceUser.superSpaceUser.isAdmin
    )
      return true;
    if (
      !isLockedByAdmin &&
      (spaceUser.superSpaceUser.canChangeRoomPin || spaceUser.canChangeRoomPin)
    )
      return true;

    return false;
  }
  openPinModal() {
    if (!this.activeOptionPlan(PLAN.LOCK_ROOM)) return;
    if (!this.isEditLockedByAdmin) return;
    this.$store.dispatch("SystemStore/setShowPinRoomModalAction", true);
    this.$store.dispatch("SystemStore/setIsChangePinAction", true);
  }
  showOpenEmojiSelector() {
    return this.$store.getters["FloatMenuStore/getOpenEmojiSelector"];
  }
  unSeenMessage(): string {
    const unSeeMessage = this.$store.getters["ChatStore/getUnSeenMessage"];
    return unSeeMessage.some((a) => a.type === CHAT_TYPE.ROOM);
  }
  @Emit()
  cameraEnabled(video: boolean): void {
    this.$store.dispatch("MeetingStore/setCameraEnabledAction", video);
    feather.replace();
  }
  @Emit()
  micEnabled(mic: boolean): void {
    this.$store.dispatch("MeetingStore/setMicEnabledAction", mic);
  }
  @Emit()
  shareScreen(share: boolean): void {
    //this.$store.dispatch("MeetingStore/setSharedScreenEnabledAction", share);
  }
  closeCallOneToOne(): void {
    if (this.disableCallButton) return;
    this.disableCallButton = true;
    const meeting = this.$store.getters["MeetingStore/getMeeting"];
    const attendee = this.$store.getters["MeetingStore/getAttendee"];
    this.$store.dispatch("UserStore/loadPreviousStatusAction", {
      store: this.$store,
      callback: (response) => {
        this.$store.dispatch("SpaceStore/updateUserInSpace", response.data);
      },
      callbackError: () => {
        // do nothing
      },
    });
    this.$store.dispatch("MeetingStore/closeMeetingOneToOneAction", {
      meetingId: meeting.MeetingId,
      attendee: attendee.AttendeeId,
      callback: (response) => {
        this.$store.dispatch("SidebarStore/setOpenCall", false);
        this.$store.dispatch("ChatStore/setMinimizeChatAction", false);
        setTimeout(() => {
          this.$store.dispatch("GraphicClientStore/resizeGraphicClientAction");
        }, 20);
      },
      callbackError: (error) => {
        console.log(error);
      },
    });
  }
  openChat(): void {
    const roomId = this.$store.getters["MeetingStore/getRoomId"];

    this.$store.dispatch("ChatStore/setMessagesAction", []);
    this.$store.dispatch("SidebarStore/setOpenChatAction", false);
    this.$store.dispatch("ChatStore/setMinimizeChatAction", false);
    setTimeout(() => {
      if (this.meetingType === MEETING_TYPE.SPEED_NETWORKING || roomId <= 0) {
        this.$store.dispatch("ChatStore/setUserChatAction", {
          ...this.userChat.superSpaceUser,
          user: this.userChat.superSpaceUser.user,
        });
        this.$store.dispatch(
          "ChatStore/setChatTypeAction",
          CHAT_TYPE.ONE_TO_ONE
        );
      } else {
        this.$store.dispatch("ChatStore/setUserChatAction", null);
        this.$store.dispatch("ChatStore/setChatTypeAction", CHAT_TYPE.ROOM);
        this.$store.dispatch("ChatStore/removeUnSeenMessageAction", {
          id: null,
          type: CHAT_TYPE.ROOM,
        });
      }

      this.$store.dispatch("SidebarStore/setOpenChatAction", true);
    }, 50);
  }

  isWebinar(): boolean {
    const space = this.$store.getters["SpaceStore/getSpace"];
    return (
      (space.superSpace.isMultiWebinarActivated
        ? this.isMultiWebinarUser()
        : this.isWebinarUser()) || this.meetingType !== MEETING_TYPE.WEBINAR
    );
  }
  isWebinarAdmin(): boolean {
    const space = this.$store.getters["SpaceStore/getSpace"];
    return (
      (space.superSpace.isMultiWebinarActivated
        ? this.isSuperSpaceAdmin()
        : this.isAdmin()) || this.meetingType !== MEETING_TYPE.WEBINAR
    );
  }
  isMultiWebinar(): boolean {
    const space = this.$store.getters["SpaceStore/getSpace"];
    return space.superSpace.isMultiWebinarActivated;
  }
  get isChatWebinarActive(): boolean {
    const meetingType = this.$store.getters["MeetingStore/getMeetingType"];
    return (
      this.$store.getters["SpaceStore/getSpace"].isWebinarChatActive ||
      meetingType !== MEETING_TYPE.WEBINAR
    );
  }

  openMenuAudio() {
    setTimeout(() => this.openAudioMenu(), 20);
  }
  openEmoji(): void {
    const show = this.$store.getters["FloatMenuStore/getOpenEmojiSelector"];
    if (!show) {
      setTimeout(() => {
        this.$store.dispatch("FloatMenuStore/setOpenEmojiSelectorAction", true);
      }, 50);
      setTimeout(() => {
        this.openEmojiSelector();
      }, 200);
    }
  }
  closeEmoji(): void {
    setTimeout(() => {
      this.closeEmojiSelector();
    }, 50);
    setTimeout(() => {
      this.$store.dispatch("FloatMenuStore/setOpenEmojiSelectorAction", false);
    }, 200);
  }
  openMenuVideo() {
    setTimeout(() => this.openVideoMenu(), 20);
  }
  pressToTalkEvent() {
    document.addEventListener("keydown", (e) => {
      if (this.pressToTalk) return;
      const pressToTalkEnabled =
        this.$store.getters["MeetingStore/getPressToTalkEnabled"];
      if (pressToTalkEnabled && (e.key === "n" || e.key === "N")) {
        this.pressToTalk = true;
        this.$emit("mic-enabled", true);
        this.$store.dispatch("MeetingStore/setMicEnabledAction", true);
      }
    });
    document.addEventListener("keyup", (e) => {
      if (!this.pressToTalk) return;
      const pressToTalkEnabled =
        this.$store.getters["MeetingStore/getPressToTalkEnabled"];
      if (pressToTalkEnabled && (e.key === "n" || e.key === "N")) {
        this.pressToTalk = false;
        this.$emit("mic-enabled", false);
        this.$store.dispatch("MeetingStore/setMicEnabledAction", false);
      }
    });
  }
  @Emit()
  async setHandUp(isHandUp) {
    // emit
    if (
      this.meetingType === MEETING_TYPE.MEETING ||
      this.meetingType === MEETING_TYPE.WEBINAR
    ) {
      const checkHandIcon = document.getElementById(`hand-up-local`);
      this.isHandUp = !this.isHandUp;
      if (!checkHandIcon || checkHandIcon.className === "") {
        const roomId = this.$store.getters["MeetingStore/getRoomId"];
        this.$store.dispatch("ChatStore/sendRoomMessageAction", {
          roomId,
          data: {
            chatMessage: "HAND_UP",
            chatMessageType: TYPES_MESSAGES.HAND_UP,
          },
        });
      }
    }
  }
  openMenu() {
    setTimeout(() => {
      this.openCallMenu();
    }, 20);
  }
  shareVideo(): void {
    if (
      this.isVideoUrlLockedByAdmin &&
      !this.isAdmin() &&
      !this.isSuperSpaceOwner()
    )
      return;
    this.$store.dispatch("MeetingStore/setOpenMeetingUrlAction", true);
  }
  async resetCall() {
    this.activateRetryCall = false;
    const roomId = this.$store.getters["MeetingStore/getRoomId"];
    if (roomId) {
      this.startLoader(this.$store, CANCELLATION_TIME.CANCEL_CALL_30);
      this.setLoaderText(
        this.$store,
        i18n.t("loader.connectingRoom").toString()
      );
      this.$store?.dispatch("MeetingStore/leaveMeetingAction", {
        roomId: roomId,
        callback: async (response) => {
          await this.$store?.dispatch("SidebarStore/setOpenCall", false);
          //Join Call
          await this.closeCall(roomId);
        },
        callbackError: (error) => {
          this.stopLoader(this.$store);
        },
      });
    }
    this.closeCallMenu();
  }
  async closeCall(roomId: any) {
    this.$store?.dispatch("MeetingStore/joinMeetingAction", {
      roomId,
      callback: async (response) => {
        if (!response.data.attendee && !response.data.meeting) return;
        await this.$store?.dispatch(
          "MeetingStore/setMeetingDataAction",
          response.data
        );
        this.$store?.dispatch(
          "MeetingStore/setIsVideoUrlLockedByAdminAction",
          response.data.isVideoUrlLockedByAdmin
        );
        await this.$store?.dispatch("SidebarStore/setOpenCall", true);
        await this.$store?.dispatch(
          "ChatStore/setMinimizeChatAction",
          !this.$store?.getters["UserStore/getConfig"].chat
            .openRoomChatByDefault
        );
        setTimeout(() => {
          this.$store?.dispatch("GraphicClientStore/resizeGraphicClientAction");
        }, 20);
        await this.$store?.dispatch("ChatStore/joinRoomChatAction", { roomId });
        this.stopLoader(this.$store);
      },
      callbackError: (err) => {
        this.stopLoader(this.$store);
      },
    });
  }
}
